const DISMISSED_STORAGE_KEY = "RaStore.auth.advisor_code_prompt_dismissed";

function getSessionStorage(): Storage | null {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return null;
  }
  return window.sessionStorage;
}

/**
 * Almikia Epic E3b (TASK-067): whether the signed-in asesora already
 * postponed ("Ahora no") the sign-in clave prompt this session. Session-
 * scoped storage (not `localStorage`) plus explicit clearing on logout
 * (see `clearAdvisorCodePromptDismissal`, wired in
 * `providers/supabase/authProvider.ts`) is what makes the prompt "ask again
 * at her next sign-in" -- the ticket's non-blocking `ASSUMPTION` -- instead
 * of being silenced forever after the first postponement.
 */
export function isAdvisorCodePromptDismissed(): boolean {
  return getSessionStorage()?.getItem(DISMISSED_STORAGE_KEY) === "true";
}

export function dismissAdvisorCodePrompt(): void {
  getSessionStorage()?.setItem(DISMISSED_STORAGE_KEY, "true");
}

export function clearAdvisorCodePromptDismissal(): void {
  getSessionStorage()?.removeItem(DISMISSED_STORAGE_KEY);
}
